// E4 fixed sentences (spec §6 E4). Web and PDF use these; the numbers come from the API (ADR-0005 "Biçimlendirme").
import type { TraceStatus } from "./api";
import { formatKg, formatNumber } from "./versions";

export const TRACE_FIFO_NOTE = "Dağıtım: FIFO tahsisi. ERP'de lot kaydı yok, bu fiziksel parti izi değildir.";
export const traceStatusText = (s: TraceStatus) => `Zincir durumu: ${formatKg(s.completeKg)} kg tam · ${formatKg(s.brokenKg)} kg kopuk`;
export const missingReceiptText = (missingKg: number) => `${formatKg(missingKg)} kg için giriş kaydı bulunamadı`;
export const wasteText = (wastePct: number) => `fire %${formatNumber(wastePct)} — girilen norm oran`;
